<template>
    <div class="joinus">
        <div style="text-align: center">
            <img src="../../assets/images/rec.png" />
        </div>
        <div class="flex-box">
            <div class="flex-item" :class="{ active: curIndex == 0 }">
                <img src="../../assets/images/icons/ju1_b.png" v-if="curIndex == 0" />
                <img src="../../assets/images/icons/ju1.png" v-else />
                <h3>社会保障<br />完善</h3>
                <hr />
            </div>
            <div class="flex-item" :class="{ active: curIndex == 1 }">
                <img src="../../assets/images/icons/ju2_b.png" v-if="curIndex == 1" />
                <img src="../../assets/images/icons/ju2.png" v-else />
                <h3>工作餐饮<br />补贴</h3>
                <hr />
            </div>
            <!-- <div class="flex-item" :class="{ active: curIndex == 2 }">
                <img src="../../assets/images/icons/ju3_b.png" v-if="curIndex == 2" />
                <img src="../../assets/images/icons/ju3.png" v-else />
                <h3>宿舍配置<br />齐全</h3>
                <hr />
            </div> -->
            <div class="flex-item" :class="{ active: curIndex == 2 }">
                <img src="../../assets/images/icons/ju4_b.png" v-if="curIndex == 2" />
                <img src="../../assets/images/icons/ju4.png" v-else />
                <h3>节日福利<br />丰富</h3>
                <hr />
            </div>
            <div class="flex-item" :class="{ active: curIndex == 3 }">
                <img src="../../assets/images/icons/ju5_b.png" v-if="curIndex == 3" />
                <img src="../../assets/images/icons/ju5.png" v-else />
                <h3>团建活动<br />精彩</h3>
                <hr />
            </div>
        </div>
        <div class="list">
            <h1 class="title">热招职位</h1>
            <p class="sub-title">简历投递邮箱：qi.li@whhiphoton.com</p>
            <div class="item" v-for="(item, index) in list" :key="'job-' + index">
                <div class="item-header">
                    <h3>{{ item.positionName }}</h3>
                    <span>招聘人数：{{ item.reqNumber }}人</span>
                    <span>{{ item.createTime }}</span>
                </div>
                <div class="content">
                    <h2>岗位职责</h2>
                    <p v-html="item.duty"></p>
                    <h2>任职要求</h2>
                    <p v-html="item.requisition"></p>
                </div>
            </div>
            <van-pagination v-model="currentPage" :total-items="total" :show-page-size="5" force-ellipses @change="handlePaginationChange" v-if="total > 10" />
        </div>
    </div>
</template>
<script>
import { handleScroll } from "@/utils";
export default {
    name: "JoinUs",
    data() {
        return {
            list: [],
            total: 0,
            currentPage: 1,
            curIndex: 0
        };
    },
    methods: {
        getJobData() {
            this.$http
                .get("/front/recruit/hft/list", {
                    params: {
                        pageNum: this.currentPage,
                        pageSize: 10,
                        versionFlag: 0
                    }
                })
                .then((res) => {
                    this.total = res.total;
                    this.list = res.rows;
                });
        },
        handlePaginationChange() {
            this.getJobData();
            handleScroll(800);
        }
    },
    mounted() {
        this.$store.commit("changeTab", 2);

        this.getJobData();
        setInterval(() => {
            const v = this.curIndex;
            if (v < 3) {
                this.curIndex = v + 1;
            } else {
                this.curIndex = 0;
            }
        }, 2000);
    }
};
</script>
<style lang="scss" scoped>
.flex-box {
    display: flex;
    justify-content: space-between;
    margin: 50px 0;
    .flex-item {
        width: 217.5px;
        height: 270px;
        border: 1px solid #ebebeb;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        h3 {
            text-align: center;
        }
        hr {
            width: 40px;
            border: none;
            border-top: 2px solid #224e97;
        }
        img {
            width: 67px;
            // height: 67px;
        }
    }
    .active {
        background: #1a98d7;
        color: white;
        hr {
            border-top: 2px solid white;
        }
    }
}
.list {
    .title {
        color: #224e97;
        font-weight: 500;
        text-align: center;
    }
    .sub-title {
        text-align: center;
        color: #4c4c4c;
    }
    .item {
        border: 1px solid #ebebeb;
        margin: 20px 0;
        .item-header {
            background: #f1f1f1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #959595;
            height: 47px;
            padding: 0 20px;
            h3 {
                color: #224e97;
                font-weight: 500;
            }
        }
        .content {
            padding: 16px 20px;
            h2 {
                font-weight: 400;
                padding-bottom: 10px;
            }
            p {
                padding-bottom: 33px;
            }
        }
    }
}
</style>
